export const prefix = `Can you take the below as input. \n`;

export const post_generator = `\n  `;
export const description = `\n Generate valuable, helpful, interesting, relavant content for a Linkedin post, on the following topic: `;
// in the structure of the Golden Circle framework
export const audience = `\n Please consider the audience to be: `;
export const tone = `\n The tone of the post should be: `;
export const language = `\n Please output the response in : `;
export const bulletsYes = `\n   
<ul>
    <li>
        <b>{{Summary of the bullet boint with no more than 5 words should be displayed here}}</b>  
        <div> 
            {{Please generate bullet points and display them here.}} 
            <span>{{Generate atleast one emoticon per bullet point in unicode representation that can be rendered in web application}}</span>
        </div>
    </li>
</ul> `;
export const bulletsNo = `\n Format the output in atleast 3 easy to read paragraphs. Do not use any markdown syntax.`;
export const emojisYes = `\n  Important is to add atleast one emoticon.  `;
export const emojisNo = `\n You Should not add any emoticons `;
export const hashtagsYes = `\n 
    <h6 class="h6">
        <div><b><i>{{Include relavant hash tags for the post here. Generate atleast 5 hashtags. }}</i></b></div>
    </h6>`;
export const hashtagsNo = `\n You Should not add any hashtags `;

// <div class="hashtags">Suggested hashtags for your post to increase its visibility:</div>
